export const forms = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'idr',
    label: 'Income Driven Repayment Plan Request',
  },
  {
    value: 'dcl',
    label: 'Direct Consolidation Loan Application',
  },
  {
    value: 'pslfa',
    label: 'Public Service Loan Forgiveness Application',
  },
  {
    value: 'pslfec',
    label: 'Public Service Loan Forgiveness Employment Certification',
  },
  {
    value: 'tlf',
    label: 'Teacher Loan Forgiveness Application',
  },
  {
    value: 'rpr',
    label: 'Repayment Plan Request',
  },
];

export const statuses = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'assigned',
    label: 'Assigned (Form not initialized)',
  },
  {
    value: 'completed',
    label: 'Completed (Awaiting submission)',
  },
  {
    value: 'submitted',
    label: 'Submitted',
  },
];

export const pslfStatus = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'assigned',
    label: 'Assigned (Form not initialized)',
  },
  {
    value: 'sent_to_employer',
    label: 'Sent to Employer (Awaiting Employer signature)',
  },
  {
    value: 'employer_signed',
    label: 'Employer Signed (Awaiting borrower signature)',
  },
  {
    value: 'completed',
    label: 'Completed (Awaiting submission)',
  },
  {
    value: 'submitted',
    label: 'Submitted',
  },
];
